<template>
    <v-container>
        <h1 class="mb-4">Articles</h1>
        <v-btn class="my-2 create-button" dark small color="primary" :loading="creating" :disabled="creating || deletingId !== null || editingId !== null" @click="createArticle">
            <v-icon dark>mdi-plus</v-icon>Create
        </v-btn>
        <v-data-table
            item-key="id"
            :headers="headers"
            :items="articles"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
        >
            <template slot="item" slot-scope="props">
                <tr>
                    <td @click="handleClick('show', props.item)">{{ props.item.title }}</td>
                    <td>
                        <div class="buttons">
                            <v-btn class="mx-2" dark small color="primary" :loading="editingId === props.item.id" :disabled="editingId !== null || creating || deletingId !== null" @click="handleClick('edit', props.item)">
                                <v-icon dark>mdi-account-edit</v-icon>
                            </v-btn>
                            <delete-button :loading="deletingId === props.item.id" @delete-entry="onDelete(props.item)" />
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <div class="pagination-wrapper">
            <v-pagination
                v-model="page"
                :length="pageCount"
                total-visible="7"
                color="primary"
            />
        </div>
    </v-container>
</template>

<script>
    import articleService from '@/services/article-service'
    import DeleteButton from '@/components/DeleteButton'
    export default {
        name: 'TeamRoute',
        components: { DeleteButton },
        data: () => {
            return {
                articles: [],
                page: 1,
                itemsPerPage: 10,
                pageCount: 1,
                creating: false,
                editingId: null,
                deletingId: null,
                headers: [{
                              text: 'Title',
                              value: 'title',
                              align: 'left',
                              sortable: true
                          },
                          {
                              text: 'Actions',
                              value: 'actions',
                              align: 'center',
                              sortable: false
                          }]
            }
        },
        watch: {
            page() {
                this.fetchAllArticles()
            }
        },
        computed: {
        },
        created() {
            this.fetchAllArticles()
        },
        methods: {
            async handleClick(action, item) {
                this.editingId = item.id
                try {
                    await this.$router.push(`/articles/${item.id}/${action}`)
                } finally {
                    this.editingId = null
                }
            },
            async onDelete(item) {
                this.deletingId = item.id
                await articleService.deleteArticleById(item.id).then(() => {
                    this.fetchAllArticles()
                })
                this.deletingId = null
            },
            async createArticle() {
                this.creating = true
                try {
                    await this.$router.push(`/articles/create`)
                } finally {
                    this.creating = false
                }
            },
            fetchAllArticles() {
                articleService.getAllArticles(this.page, this.itemsPerPage).then(resp => {
                    this.articles = resp.data.data
                    this.page = resp.data.current_page
                    this.pageCount = resp.data.last_page
                })
            },
            mapTrueFalse(value) {
                if (value) {
                    return 'Yes'
                }
                return 'No'
            }
        }
    }
</script>

<style scoped>
td {
    min-width: 150px;
}
.buttons {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 16px;
}
</style>




